<template>
  <div class="menu-item-child solution">
    <ul class="solutionTabbar">
      <template v-for="(item, index) in solution">
        <li :key="index" :class="item.id == parent ? 'active' : ''">
          {{ item.title }}
        </li>
      </template>
    </ul>
    <template v-for="(item, index) in solution">
      <div
        :key="index"
        :class="
          item.id == parent
            ? 'solutionTabbar-content active'
            : 'solutionTabbar-content'
        "
      >
        <h2 class="title">{{ item.title }}</h2>
        <p class="desc"></p>
        <ul class="link-wrap">
          <template v-for="(citem, cindex) in item.child">
            <li :key="cindex">
              {{ citem.title }}
            </li>
          </template>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      parent: 0,
      current: 0,
      solution: [
        {
          id: 1,
          title: "数据中心",
          child: [
            {
              id: 11,
              title: "数据中心监控管理系统",
            },
          ],
        },
        {
          id: 2,
          title: "行业智能化",
          child: [
            {
              id: 21,
              title: "智慧校园管理系统",
            },
            {
              id: 23,
              title: "医疗后勤信息化管理平台",
            },
          ],
        },
        {
          id: 3,
          title: "系统集成",
          child: [
            {
              id: 31,
              title: "建筑智能管理系统",
            },
          ],
        },
        {
          id: 4,
          title: "运维服务",
          child: [
            {
              id: 41,
              title: "智能运维管理系统",
            },
            {
              id: 42,
              title: "设备养护平台",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
/*媒体查询*/
/*屏幕宽度大于1024px的时候执行里面的css*/
@media only screen and (min-width: 1024px) {
  .menu-item-child {
    display: none;
    position: absolute;
    left: -5rem /* 80/16 */;
    padding: 2rem /* 32/16 */ 1.75rem /* 28/16 */;
    width: 41.875rem /* 670/16 */;
    color: #fff;
    background: #141414;
    box-sizing: border-box;
    top: 3.1rem;
  }
}
/*媒体查询*/
/*屏幕宽度小于1024px的时候执行里面的css*/
@media only screen and (max-width: 1024px) {
}
</style>


// WEBPACK FOOTER //
// src/layout/navBar/comps/solution.vue